import { BaseModel } from "@/models/base.model"
import { type IActivity } from "@/interfaces/api/activity.interface"
import { ActivityTypes } from "@/enums/models/activity-types"
import { type Moment } from "moment/moment"
import { activityTypeToName } from "@/helper/activity-helper.ts"

export class Activity extends BaseModel implements IActivity {
  public static className = "Activity" // Used for socket communication.
  public static verboseName = "activiteit"

  workPeriod: string
  workPeriodOwnerId?: string

  type: ActivityTypes
  timeStart: Moment | null
  timeEnd: Moment | null
  description: string

  constructor(activity: IActivity) {
    super(activity)

    this.workPeriod = activity.workPeriod
    this.workPeriodOwnerId = activity.workPeriodOwnerId

    this.type = activity.type
    this.timeStart = activity.timeStart
    this.timeEnd = activity.timeEnd
    this.description = activity.description
  }

  public getTypeString(): string {
    if (this.type) {
      return activityTypeToName(this.type)
    }
    return "<type?>"
  }
}
